"use strict";

var _classCallCheck = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _createClass = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/travis/gopath/src/github.com/jaegertracing/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _HtmlLayer = _interopRequireDefault(require("./HtmlLayer"));

var _MeasurableNodes = _interopRequireDefault(require("./MeasurableNodes"));

var _SvgLayer = _interopRequireDefault(require("./SvgLayer"));

var _types = require("./types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createRefs(length) {
  var rv = [];

  for (var i = 0; i < length; i++) {
    rv.push(React.createRef());
  }

  return rv;
}

var MeasurableNodesLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MeasurableNodesLayer, _React$PureComponent);

  _createClass(MeasurableNodesLayer, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var vertices = nextProps.graphState.vertices;
      var stVertices = prevState.vertices;

      if (vertices === stVertices) {
        return null;
      }

      return {
        vertices: vertices,
        nodeRefs: createRefs(vertices.length)
      };
    }
  }]);

  function MeasurableNodesLayer(props) {
    var _this;

    _classCallCheck(this, MeasurableNodesLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MeasurableNodesLayer).call(this, props));
    var graphState = props.graphState;
    var vertices = graphState.vertices;
    _this.state = {
      vertices: vertices,
      nodeRefs: createRefs(vertices.length)
    };
    return _this;
  }

  _createClass(MeasurableNodesLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.measureNodes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.measureNodes();
    }
  }, {
    key: "measureNodes",
    value: function measureNodes() {
      var _this$props$graphStat = this.props.graphState,
          layoutPhase = _this$props$graphStat.layoutPhase,
          vertices = _this$props$graphStat.vertices;

      if (layoutPhase !== _types.ELayoutPhase.CalcSizes) {
        return;
      }

      var nodeRefs = this.state.nodeRefs;

      if (!nodeRefs) {
        return;
      }

      var _this$props = this.props,
          layerType = _this$props.layerType,
          measureNode = _this$props.measureNode,
          senderKey = _this$props.senderKey,
          setSizeVertices = _this$props.setSizeVertices;
      var current = null;
      var utils = measureNode && {
        layerType: layerType,
        getWrapper: function getWrapper() {
          if (current) {
            return current.getRef();
          }

          throw new Error('Invalid scenario');
        },
        getWrapperSize: function getWrapperSize() {
          if (current) {
            return current.measure();
          }

          throw new Error('Invalid scenario');
        }
      };
      var sizeVertices = [];

      for (var i = 0; i < nodeRefs.length; i++) {
        current = nodeRefs[i].current;
        var vertex = vertices[i];

        if (current) {
          sizeVertices.push(_objectSpread({
            vertex: vertex
          }, measureNode && utils ? measureNode(vertex, utils) : current.measure()));
        }
      }

      setSizeVertices(senderKey, sizeVertices);
    }
  }, {
    key: "render",
    value: function render() {
      var nodeRefs = this.state.nodeRefs;

      if (nodeRefs) {
        var _this$props2 = this.props,
            getClassName = _this$props2.getClassName,
            _this$props2$graphSta = _this$props2.graphState,
            layoutVertices = _this$props2$graphSta.layoutVertices,
            renderUtils = _this$props2$graphSta.renderUtils,
            vertices = _this$props2$graphSta.vertices,
            layerType = _this$props2.layerType,
            renderNode = _this$props2.renderNode,
            setOnNode = _this$props2.setOnNode;
        var LayerComponent = layerType === _types.ELayerType.Html ? _HtmlLayer.default : _SvgLayer.default;
        return React.createElement(LayerComponent, Object.assign({
          classNamePart: "MeasurableNodesLayer"
        }, this.props), React.createElement(_MeasurableNodes.default, {
          nodeRefs: nodeRefs,
          getClassName: getClassName,
          layerType: layerType,
          renderNode: renderNode,
          renderUtils: renderUtils,
          vertices: vertices,
          layoutVertices: layoutVertices,
          setOnNode: setOnNode
        }));
      }

      return null;
    }
  }]);

  return MeasurableNodesLayer;
}(React.PureComponent);

exports.default = MeasurableNodesLayer;